import _ from 'underscore';
import { processor, withSiteMap as withSiteMapInternal, allSiteMap } from '@bingads-webui-react/with-site-map';
import { processCampaignType } from './processors/campaign-type-processor';
import { processCampaignId } from './processors/campaign-id-processor';
import {
  processSmartCampaign, processSmartCampaignSearch
} from './processors/smart-campaign-processor';
import { processPmaxCampaignPageMenu } from './processors/pmax-campaign-page-menu-processor';
import { processPmaxRetailCampaignPageMenu } from './processors/pmax-campaign-store-processor';
import { processSmartShoppingCampaign } from './processors/smart-shopping-campaign-processor';
import { processHotelCampaign } from './processors/hotel-campaign-processor';
import { processMixedModeAdGroup } from './processors/mixed-mode-adgroup-processor';
import { processGlobalFilter } from './processors/global-filter-processor';
import { processImportCenterMode } from './processors/import-center-mode-processor';
import { processAssetReportAdType } from './processors/asset-report-ad-type-processor';
import { processMMCMenu } from './processors/mmc-menu-processor';
import { processCopilotRegionRestriction } from './processors/copilot-region-restriction-processor';

_.extend(processor, {
  processPermissions: processor.processPermissionsCached,
  processScope: processor.processScopeCached,
  processPath: processor.processPathCached,
  processImportCenterMode,
  processCampaignType,
  processCampaignId,
  processGlobalFilter,
  processSmartCampaign,
  processSmartCampaignSearch,
  processSmartShoppingCampaign,
  processHotelCampaign,
  processMixedModeAdGroup,
  processPmaxCampaignPageMenu,
  processPmaxRetailCampaignPageMenu,
  processAssetReportAdType,
  processMMCMenu,
  processCopilotRegionRestriction,
});
export { processor };

export const processorSet = {
  basic: [processor.processPermissions, processor.processAccountLinkPermission, processCampaignType, processSmartCampaignSearch, processor.processXandrAccessible],
  default: [
    processor.processPermissions,
    processor.processAccountLinkPermission,
    processor.processScope,
    processGlobalFilter,
    processor.processPath,
    processor.processXandrAccessible,
  ],
  all: [
    processImportCenterMode,
    processMixedModeAdGroup,
    processCopilotRegionRestriction,
    processor.processPermissions,
    processor.processAccountLinkPermission,
    processor.processScope,
    processGlobalFilter,
    processCampaignType,
    processCampaignId,
    processSmartCampaign,
    processSmartShoppingCampaign,
    processPmaxRetailCampaignPageMenu,
    processHotelCampaign,
    processAssetReportAdType,
    processMMCMenu,
    processor.processPath,
    processor.processCustomMapper,
    processor.processXandrAccessible,
  ],
};

export const withSiteMap = (
  Component, processors = processorSet.default,
  siteMap = allSiteMap, rootId = null, propName = 'siteMap'
) => withSiteMapInternal(Component, processors, siteMap, rootId, propName);
